/**
 * Home page widget types and data references
 */

import { createExtensionDataRef } from '@backstage/frontend-plugin-api';

/**
 * Data ref for widget title
 */
export const homeWidgetTitleDataRef = createExtensionDataRef<string>().with({
  id: 'appvia.home.widget.title',
});

/**
 * Data ref for widget priority (lower = appears first)
 */
export const homeWidgetPriorityDataRef = createExtensionDataRef<number>().with({
  id: 'appvia.home.widget.priority',
});

/**
 * Data ref for widget column placement
 */
export const homeWidgetColumnDataRef = createExtensionDataRef<'left' | 'right'>().with({
  id: 'appvia.home.widget.column',
});

/**
 * Metadata for home page widgets
 */
export interface HomeWidgetMetadata {
  title?: string;
  priority?: number;
  column?: 'left' | 'right';
}
